import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PeriodType, PublicState } from 'utils/constant';
import { IAttendanceProps, IDailyProps } from 'utils/types/operationTypes';
import useCurrencyDropQuery from 'hooks/queries/common/useCurrencyDropQuery';
import { theme } from 'utils/style/theme';
import DefaultButton from 'components/button/DefaultButton';
import ToggleButton from 'components/button/ToggleButton';
import InputFlexBox from 'components/container/InputFlexBox';
import InputWrappingBox from 'components/container/InputWrappingBox';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import UtcTimer from 'components/etc/UtcTimer';
import DefaultDatePicker from 'components/input/DefaultDatePicker';
import DefaultInput from 'components/input/DefaultInput';
import DefaultRadio from 'components/input/DefaultRadio';
import DefaultLayout from 'components/layout/DefaultLayout';
import DayListComponent from './DayListComponent';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
/**
 * * 운영 관리 - 출석 보상 등록 & 수정
 */

const AttendanceInputPage = () => {
  const periodType = PeriodType();
  const { t } = useTranslation();
  const publicState = PublicState();
  const { attendanceId } = useParams();
  console.log(attendanceId);
  const dateFormat = 'YYYY-MM-DD HH:mm:00';
  const today = dayjs().format('YYYY-MM-DD HH:mm:00');
  const [detailData, setDetailData] = useState<IAttendanceProps>();
  const [dailyList, setDailyList] = useState<IDailyProps[]>();
  const navigate = useNavigate();
  const { data: currencyDropData } = useCurrencyDropQuery('');

  /// input & radio event
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetailData({ ...detailData!, [name]: value });
  };

  const handleSubmit = async () => {
    console.log('');
  };
  const fetchDetailData = async () => {
    ('');
  };
  const handleGoBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (attendanceId === '0') {
      // 등록
      setDetailData({
        attendance_id: 0,
        name: '',
        kind: 7,
        reset_period: 0, // 연속 출석 선택할 때 필요
        from_date: today,
        to_date: today,
        is_public: 0,
        is_loop: 0,
      });
    } else {
      fetchDetailData().catch(console.log);
    }
  }, []);
  return (
    <DefaultLayout>
      <SubmitFlexBox>
        <>
          <DefaultButton
            onClick={handleGoBack}
            style={{ marginRight: '1rem' }}
            typename='sub'
          >
            {t('attendanceID.header.backButton')}
          </DefaultButton>
          <DefaultButton onClick={handleSubmit}>
            {t('attendanceID.header.submitButton')}
          </DefaultButton>
        </>
      </SubmitFlexBox>
      <InputFlexBox style={{ marginTop: '3rem' }}>
        <InputWrappingBox left>
          <DefaultInput
            title={t('attendanceID.form.title')}
            name='title'
            value={detailData?.name}
          />
          <DefaultRadio
            title={t('attendanceID.form.kind')}
            name='kind'
            defaultValue={detailData?.kind}
            onChange={handleInputChange}
            optionList={periodType}
            style={{ marginBottom: '1rem' }}
          />
          <>
            {/* 연속 출석 선택했을 때 */}
            {detailData?.kind === -1 && (
              <DefaultInput
                title={t('attendanceID.form.resetPeriod')}
                value={detailData?.reset_period}
                name='reset_period'
              />
            )}
          </>
          <DefaultDatePicker title={t('attendanceID.form.period')} bottom />
          <UtcTimer />
          <InputFlexBox style={{ marginTop: theme.margins.bottomInPage }}>
            <DefaultRadio
              title={t('attendanceID.form.isPublic')}
              name='is_public'
              optionList={publicState}
              defaultValue={detailData?.is_public}
              onChange={handleInputChange}
            />
            <DefaultRadio
              title={t('attendanceID.form.isLoop')}
              name='is_loop'
              optionList={[
                {
                  key: 0,
                  value: 0,
                  text: t('attendanceID.form.doNotRepeat'),
                },
                {
                  key: 1,
                  value: 1,
                  text: t('attendanceID.form.repeat'),
                },
              ]}
              defaultValue={detailData?.is_loop}
              onChange={handleInputChange}
            />
            {/* <ToggleButton
              title="공개 여부"
              name="is_public"
              //   onChange={handleInputChange}
              //   checked={detailData?.is_public === 1 ? true : false}
            /> */}
            {/* <ToggleButton
              title="반복 여부"
              name="is_loop"
              //   onChange={handleInputChange}
              //   checked={detailData?.is_loop === 1 ? true : false}
            /> */}
          </InputFlexBox>
        </InputWrappingBox>
        <InputWrappingBox>
          <DayListComponent />
        </InputWrappingBox>
      </InputFlexBox>
    </DefaultLayout>
  );
};

export default AttendanceInputPage;
